import React, { FC, useState } from 'react';

import { IListItem } from '@/contentful/utils/listItem';

import AccordionItem from './part-accordion-item';

import styles from './part-accordion.module.scss';

interface IAccordionProps {
  list: IListItem[];
}

const Accordion: FC<IAccordionProps> = ({ list = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    list.length && (
      <ul className={styles.accordion}>
        {list.map((el, i) => (
          <AccordionItem
            element={el}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            index={i}
            key={el.title}
          />
        ))}
      </ul>
    )
  );
};

export default Accordion;
